<nz-layout>
  <nz-header class="section-header">
    {{'Daily Monitoring' | translate}}
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path == componentPaths.vitalSigns) {
        <app-vital-signs [id]="cm.path" />
      }
      @if (cm.path == componentPaths.arterialBloodGas) {
        <app-arterial-blood-gas [id]="cm.path" />
      }
      @if (cm.path == componentPaths.glasgow) {
        <app-glasgow [id]="cm.path" />
      }
      @if (cm.path == componentPaths.glucose) {
        <app-glucose [id]="cm.path" />
      }
      @if (cm.path == componentPaths.nutritionIntake) {
        <app-nutrition-intake [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>